export function ValidateEmail(email:string) {
    var re = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/;
    if (re.exec(email) == null) {
      return false;
    }
    return true;
  }